
<template>
  <div class="portada-arley" ref="rootRef" aria-label="Portada de XV Años">
    <div class="fondo-gradiente">
      <div class="fondo-arco"></div>
    </div>

    <!-- Lluvia de polvo mágico optimizada parasdsada bajo consumo de RAM -->
    <div class="polvo-dorado-container">
      <div v-for="n in 16" :key="n" :class="['particula-dorada', 'estrella-' + ((n % 3) + 1)]"></div>
    </div>

    <img src="@/assets/Copia de Diseño sin título (4).png" class="adorno velas-superior" alt="" />
    <!-- Mariposa con clase de aleteo optimizada con GPU -->
    <img src="@/assets/mariposaa.png" class="flor flor-superior-derecha mariposa-aleteo" alt="" />

    <img src="@/assets/brillo.avif" class="brillo brillo-izq-1" alt="" />
    <img src="@/assets/brillo.avif" class="brillo brillo-izq-2" alt="" />
    <img src="@/assets/brillo.avif" class="brillo brillo-der-1" alt="" />
    <img src="@/assets/brillo.avif" class="brillo brillo-der-2" alt="" />

    <!-- Mariposas grandes con aleteo mágico -->
    <img src="@/assets/mariposaa.png" class="flor-grande flor-izq-1 mariposa-aleteo" alt="" />
    <img src="@/assets/Elements (63).avif" class="flor-grande flor-izq-2" alt="" />
    <img src="@/assets/florblush.png" class="flor-grande flor-izq-3" alt="" />

    <img src="@/assets/florblush.png" class="flor-grande flor-der-1" alt="" />
    <img src="@/assets/florblush.png" class="flor-grande flor-der-2" alt="" />
    <img src="@/assets/flor-izq.png" class="flor-grande flor-der-3" alt="" />

    <div class="imagen-xv-wrapper shadow-custom">
      <img src="@/assets/DSC_1018_11zon.webp" class="imagen-xv" alt="Foto protagonista" />
    </div>

    <header class="texto-cabecera">
      <p class="prefijo-xv text-uppercase"></p><br>
      <h1 class="nombre-mariel">
        <span class="nombre-principal">Yaretzi </span>
        <span class="apellido-principal">Azucena </span>
      </h1>
    </header>
  </div>
</template>

<script>
import { onMounted, ref, nextTick } from 'vue'
import gsap from 'gsap'

export default {
  name: 'PortadaArley',
  setup() {
    const rootRef = ref(null)

    onMounted(async () => {
      await nextTick()

      const $ = (sel) => Array.from(gsap.utils.toArray(sel)).filter(Boolean)

      // Elementos a animar
      const fondo = $('.fondo-gradiente')
      const arco = $('.fondo-arco')
      const foto = $('.imagen-xv-wrapper')
      const textos = $('.texto-cabecera, .controles-inferiores, .parrafo-presentacion-wrapper')
      const floresNormales = $('.velas-superior, .flor-superior-derecha')
      const floresGrandes = $('.flor-grande')
      const brillos = $('.brillo')
      const controles = $('.controles-inferiores')
      const playIcon = $('.play-icon')
      const seekBar = $('.seek-bar')

      const totalElementos = [].concat(fondo, arco, foto, textos, floresNormales, floresGrandes, brillos, controles, playIcon, seekBar)
      gsap.set(totalElementos, { autoAlpha: 0, y: 20 })
      gsap.set(brillos, { scale: 0 })

      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (!e.isIntersecting) return

          const tl = gsap.timeline({ defaults: { ease: 'power2.out' } })

          tl.to(fondo, { autoAlpha: 1, y: 0, duration: 0.8 })
            .to(arco, { autoAlpha: 1, y: 0, duration: 0.7 }, '-=0.5')

          tl.fromTo(
            foto,
            { scale: 0.94, y: 30 },
            { autoAlpha: 1, scale: 1, y: 0, duration: 1 },
            '-=0.4'
          )

          const textosYFlores = [].concat(textos, floresNormales)
          tl.to(
            textosYFlores,
            {
              autoAlpha: 1,
              y: 0,
              duration: 0.8,
              stagger: 0.1
            },
            '-=0.6'
          )

          tl.to(
            floresGrandes,
            {
              autoAlpha: 1,
              y: 0,
              duration: 0.8,
              stagger: 0.08
            },
            '-=0.5'
          )

          tl.to(
            brillos,
            {
              autoAlpha: 1,
              scale: 1,
              duration: 0.8,
              stagger: 0.15,
              onComplete: () => {
                gsap.to(brillos, {
                  opacity: 0.5,
                  scale: 1.08,
                  duration: 1.2,
                  repeat: -1,
                  yoyo: true,
                  ease: 'sine.inOut'
                })
              }
            },
            '-=0.3'
          )

          tl.to(controles, { autoAlpha: 1, y: 0, duration: 0.6 }, '-=0.2')

          // Animaciones continuas optimizadas para GPU
          gsap.to(foto, {
            scale: 1.01,
            duration: 4.5,
            yoyo: true,
            repeat: -1,
            ease: 'sine.inOut'
          })

          io.disconnect()
        })
      }, { threshold: 0.3 })

      if (rootRef.value) io.observe(rootRef.value)
    })

    return { rootRef }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;700&family=Montserrat:wght@400;700&family=Great+Vibes&display=swap');

.portada-arley {
  position: relative;
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  overflow: visible;
  padding: 48px 16px 56px;
  box-sizing: border-box;
}

/* EFECTO DE ALETEO MÁGICO OPTIMIZADO CON GPU */
@keyframes aleteoMagico {
  0% { transform: scale3d(1, 1, 1) rotate(0deg) translateZ(0); }
  30% { transform: scale3d(0.85, 1.05, 1) rotate(-3deg) translateZ(0); }
  50% { transform: scale3d(1.05, 0.95, 1) rotate(3deg) translateZ(0); }
  70% { transform: scale3d(0.9, 1.02, 1) rotate(-2deg) translateZ(0); }
  100% { transform: scale3d(1, 1, 1) rotate(0deg) translateZ(0); }
}

.mariposa-aleteo {
  animation: aleteoMagico 2s ease-in-out infinite;
  transform-origin: center;
  will-change: transform;
}

/* POLVO MÁGICO REDUCIDO ESTRATÉGICAMENTE (OPTIMIZADO PARA BAJO RAM) */
.polvo-dorado-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 4;
  overflow: hidden;
}

.particula-dorada {
  position: absolute;
  clip-path: polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%);
  will-change: transform, opacity;
  animation: flotarEstrellita linear infinite;
}

/* Tamaños variados */
.estrella-1 { width: 4px; height: 4px; animation-duration: 3.2s; }
.estrella-2 { width: 6px; height: 6px; animation-duration: 4.8s; }
.estrella-3 { width: 3.5px; height: 3.5px; animation-duration: 3.8s; }

/* 16 posiciones clave distribuidas en los márgenes y laterales para no saturar memoria */
.particula-dorada:nth-child(1)  { left: 4%;  top: 8%;  animation-delay: 0.2s; }
.particula-dorada:nth-child(2)  { left: 93%; top: 12%; animation-delay: 1.4s; }
.particula-dorada:nth-child(3)  { left: 6%;  top: 28%; animation-delay: 0.7s; }
.particula-dorada:nth-child(4)  { left: 91%; top: 32%; animation-delay: 2.1s; }
.particula-dorada:nth-child(5)  { left: 3%;  top: 52%; animation-delay: 1.0s; }
.particula-dorada:nth-child(6)  { left: 95%; top: 58%; animation-delay: 0.4s; }
.particula-dorada:nth-child(7)  { left: 5%;  top: 78%; animation-delay: 1.8s; }
.particula-dorada:nth-child(8)  { left: 92%; top: 83%; animation-delay: 0.9s; }
.particula-dorada:nth-child(9)  { left: 22%; top: 3%;  animation-delay: 2.3s; }
.particula-dorada:nth-child(10) { left: 78%; top: 4%;  animation-delay: 1.2s; }
.particula-dorada:nth-child(11) { left: 18%; top: 97%; animation-delay: 0.5s; }
.particula-dorada:nth-child(12) { left: 82%; top: 96%; animation-delay: 1.7s; }
.particula-dorada:nth-child(13) { left: 11%; top: 22%; animation-delay: 1.1s; }
.particula-dorada:nth-child(14) { left: 89%; top: 44%; animation-delay: 2.0s; }
.particula-dorada:nth-child(15) { left: 14%; top: 68%; animation-delay: 0.3s; }
.particula-dorada:nth-child(16) { left: 86%; top: 72%; animation-delay: 1.5s; }

@keyframes flotarEstrellita {
  0% {
    transform: translateY(0px) scale(0.5) rotate(0deg) translateZ(0);
    opacity: 0.1;
  }
  50% {
    transform: translateY(-25px) scale(1.1) rotate(180deg) translateZ(0);
    opacity: 0.75;
  }
  100% {
    transform: translateY(-50px) scale(0.5) rotate(360deg) translateZ(0);
    opacity: 0;
  }
}

/* FONDO (GRADIENTE Y ARCO) */
.fondo-gradiente {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  z-index: -2;
}

.fondo-arco {
  position: absolute;
  top: 15vh;
  left: 50%;
  transform: translateX(-50%) translateZ(0);
  width: min(92vw, 360px);
  height: 80vh;
  border-radius: 180px 180px 0 0;
  z-index: -1;
}

/* IMAGEN CENTRAL OPTIMIZADA CON GPU */
.imagen-xv-wrapper {
  width: min(92vw, 360px);
  height: calc(min(92vw, 360px) * 1.5);
  margin-top: 38vh;
  margin-bottom: auto;
  border-radius: 180px 180px 0 0;
  overflow: hidden;
  z-index: 2;
  background: #fff;
  transform: translateZ(0);
  will-change: transform;
}

.imagen-xv {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.shadow-custom {
  box-shadow: 
    0 10px 30px rgba(0,0,0,.15),
    0 2px 6px rgba(0,0,0,.05);
}

/* TEXTOS */
.texto-cabecera {
  max-width: 620px;
  text-align: center;
  position: absolute;
  top: 6vh;
  left: 50%;
  transform: translateX(-50%) translateZ(0);
  z-index: 3;
}

.prefijo-xv {
  font-family: 'bethany', sans-serif;
  font-weight: 700;
  font-size: clamp(16px, 2vw, 18px);
  color: #fff;
  margin: 0; 
  letter-spacing: 0.15em;
  margin-top: 70px;
  padding-bottom: 19px;
}

.nombre-mariel {
  margin: 0;
  line-height: 1.1;
}

.nombre-principal {
  font-family: 'CynthiaJuneJF', serif !important;
  font-weight: 400;
  font-size: clamp(68px, 22vw, 65px);
  color: #2b5440;
  display: block;
  letter-spacing: 0px;
}

.apellido-principal {
  font-family: 'CynthiaJuneJF', serif !important;
  font-weight: 400;
  font-size: clamp(68px, 22vw, 65px);
  color: #2b5440;
  display: block;
  margin-top: -20px;
  letter-spacing: 4px;
}

/* ELEMENTOS GRÁFICOS CON ACELERACIÓN GPU */
.flor, .flor-grande, .adorno, .brillo {
  position: absolute;
  transform-origin: center;
  will-change: transform, opacity;
  object-fit: contain;
  transform: translateZ(0);
}

.adorno.velas-superior {
  top: -60px; right:-220px; z-index: 1;
  width: min(550vw, 550px);
  transform: rotate(8deg) translateZ(0);
}

.flor-superior-derecha {
  top: 10px; right: -20px; z-index: 1;
  width: min(45vw, 210px)!important; 
}

/* FLORES IZQUIERDAS */
.flor-izq-1 {
  top: 34vh; left: -19vw; z-index: 3;
  width: min(44vw, 140px);
}
.flor-izq-2 {
  top: 2vh; left: -65vw !important; z-index: 3;
  width: min(38vw, 80px) !important;
}
.flor-izq-3 {
  bottom: 38vh; left: -22vw !important; z-index: 3;
  width: min(39vw, 140px) !important;
  transform: rotate(62deg) translateZ(0) !important;
}

/* FLORES DERECHAS */
.flor-der-1 {
  top: 36vh; right: -39vw; z-index: 1;
  width: min(70vw, 310px);
  transform: rotate(-12deg) translateZ(0) !important;
}
.flor-der-2 {
  bottom: 10vh; right: -12vw; z-index: 3;
  width: min(46vw, 110px);
}
.flor-der-3 {
  bottom: 8vh; right: -10vw; z-index: -10;
  width: min(44vw, 240px);
}

/* BRILLOS IZQUIERDA */
.brillo-izq-1 {
  top: -5px; left: -18vw; z-index: 0;
  width: 320px; opacity: 0.6;
}
.brillo-izq-2 {
  bottom: 28vh; left: 5vw; z-index: 4;
  width: 100px; opacity: 0.5;
}

/* BRILLOS DERECHA */
.brillo-der-1 {
  top: 22vh; right: 6vw; z-index: 0;
  width: 110px; opacity: 0.6;
}
.brillo-der-2 {
  bottom: 7vh; right: -3vh; z-index: 4;
  width: 140px; opacity: 0.7;
}

@media (min-width: 992px){
  .portada-arley { padding-top: 64px; }
  .texto-cabecera { top: 8vh; }
}

@media (max-width: 500px) {
  .flor-izq-1, .flor-izq-2, .flor-izq-3 { left: -14vw; }
  .flor-der-1, .flor-der-2, .flor-der-3 { right: -14vw; }
}
</style>

```